import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { useRelationship } from '@wellesley/user'
import { Relationship } from '@wellesley/openapi'
import RowItem, { getRowId } from './RowItem'
import { ScrolledListProps } from './types'

const ScrolledList: FC<ScrolledListProps> = ({
  list,
  className,
  ...handlers
}) => {
  const { relationship, isLoading: isRelationshipLoading } = useRelationship({
    userId: list?.map(getRowId),
  })

  return (
    <div
      className={cn(
        'no-scrollbar overflow-y-auto overflow-x-hidden',
        className,
      )}
      data-testid="f_list"
    >
      {list?.map((item) => {
        const id = getRowId(item)

        return (
          <RowItem
            key={id}
            item={item}
            relationship={(relationship as { [key: string]: Relationship })[id]}
            isRelationshipLoading={isRelationshipLoading}
            className="py-2.5"
            {...handlers}
          />
        )
      })}
    </div>
  )
}

export default ScrolledList
